/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Pipe, PipeTransform } from '@angular/core';

/**
 * Capitalizes words in a string, or only the first word
 *
 * @example
 * {{ 'hello world' | capitalize }}
 * <!--'Hello World'-->
 * {{ 'hello world' | capitalize: false }}
 * <!--'Hello world'-->
 */

@Pipe({
    name: 'capitalize',
    standalone: true,
})
export class CapitalizePipe implements PipeTransform {
	transform(input: any, all = true): any {
		if (!this.isString(input)) {
			return input;
		}

		if (!all) {
			return this.upperFirst(input.toLowerCase());
		} else {
			return input
				.toLowerCase()
				.split(' ')
				.map((value: string) => this.upperFirst(value))
				.join(' ');
		}
	}

	private isString(value: any): boolean {
		return typeof value === 'string';
	}

	private upperFirst(value: string): string {
		return value.slice(0, 1).toUpperCase() + value.slice(1);
	}
}
